import { render, staticRenderFns } from "./WhalesTab.vue?vue&type=template&id=df29d642"
import script from "./WhalesTab.vue?vue&type=script&lang=js"
export * from "./WhalesTab.vue?vue&type=script&lang=js"
import style0 from "./WhalesTab.vue?vue&type=style&index=0&id=df29d642&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports